<p>Registration of new user succesfull</p>
<p>Please chech your inbox for verfication mail before login in</p>
